import Vue from "vue";
import Vuex from "vuex";

// import * as getters from './getters';

// import auth from "./auth";

import supplier from "./modules/supplier";
import product from "./modules/product";

Vue.use(Vuex);

export default new Vuex.Store({
  // getters,

  modules: {
    supplier,
    product
  },
  strict: true
});



// WEBPACK FOOTER //
// ./src/store/index.js